<script>
import DatePicker from "vue2-datepicker"; // add DatePicker
import {
  required,
  minLength,
  maxLength,
  minValue,
  maxValue,
  requiredIf,
} from "vuelidate/lib/validators";
import category from "../../helpers/list/category";
import city from "../../helpers/list/city";

export default {
  components: { DatePicker },
  props: {},

  data() {
    return {
      name1: "",
      name2: "",
      name3: "",
      name4: "",
      family_name: "",
      mother_name: "",
      date_wound: "",
      category_id: "",
      disability_ratio: "",
      dept: "",
      city_id: "",

      //lists
      list_categories: category,
      list_cities: city,
    };
  },
  validations: {
    name1: { required, minLength: minLength(2), maxLength: maxLength(15) },
    name2: { required, minLength: minLength(2), maxLength: maxLength(15) },
    name3: { required, minLength: minLength(2), maxLength: maxLength(15) },
    name4: { required, minLength: minLength(2), maxLength: maxLength(15) },
    family_name: { required, minLength: minLength(2), maxLength: maxLength(15) },
    mother_name: { required, minLength: minLength(2), maxLength: maxLength(50) },
    date_wound: { required },
    category_id: { required },
    disability_ratio: {
      required: requiredIf(function () {
        return this.getInjuryCategory();
      }),
      minValue: minValue(75),
      maxValue: maxValue(100),
    },
    dept: { required, minLength: minLength(2), maxLength: maxLength(50) },
    city_id: { required },

    form: [
      "name1",
      "name2",
      "name3",
      "name4",
      "family_name",
      "mother_name",
      "date_wound",
      "category_id",
      "disability_ratio",
      "dept",
      "city_id",
    ],
  },
  methods: {
    getMartyrCategory() {
      return this.category_id == "1";
    },
    getInjuryCategory() {
      return this.category_id == "2";
    },
    // validate
    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      this.$emit("on-validate", this.$data, isValid);
      return isValid;
    },
  },
};
</script>

<template>
  <!-- start page title -->
  <div>
    <div class="row">
      <!-- modal info -->
      <div class="col-md-12">
        <div class="about-info">
          <i class="bx bx-left-arrow-circle bx-fade-left"></i>
          <a href="javascript: void(0);" v-b-modal.modal-info class="text-dark"
            >قراءة التعليمات</a
          >
        </div>
      </div>
      <b-modal
        id="modal-info"
        size="md"
        title="قراءة التعليمات"
        title-class="font-18"
        hide-footer
      >
        <h5 class="mb-2">تعليمات ملء استمارة الحج .</h5>
        <ul class="li-info">
          <li>الدقة في ملء بيانات الاستمارة .</li>
          <li>
            عند رفع المرفقات في الحقول المخصصة للمرفقات يجب ان تكون بصيغة ( JPG, JPEG ,
            PNG , pdf ) وبحجم لا يتجاوز ( 5mb )
          </li>
        </ul>
      </b-modal>
      <!-- title -->
      <hr class="hr-title" />
      <div class="break-title">
        <h5 class="mb-4">البيانات الشخصية للمضحي (الشهيد او الجريح)</h5>
      </div>

      <b-form-group class="col-md-3 mb-3" label="الاسم : " label-for="name1">
        <b-form-input
          id="name1"
          type="text"
          placeholder="ادخل الاسم"
          v-model="name1"
          :class="{ 'is-invalid': $v.name1.$error }"
        ></b-form-input>
        <div v-if="$v.name1.$error" class="invalid-feedback">
          <span v-if="!$v.name1.required">هذا الحقل الزامي</span>
          <span v-if="!$v.name1.minLength">يجب أن يتكون الاسم من حرفين على الأقل</span>
          <span v-if="!$v.name1.maxLength">يجب أن يتكون الاسم من 15 حرف على الاكثر</span>
        </div>
      </b-form-group>
      <b-form-group class="col-md-3 mb-3" label="اسم الاب : " label-for="name2">
        <b-form-input
          id="name2"
          type="text"
          placeholder="ادخل اسم الاب"
          v-model="name2"
          :class="{ 'is-invalid': $v.name2.$error }"
        ></b-form-input>
        <div v-if="$v.name2.$error" class="invalid-feedback">
          <span v-if="!$v.name2.required">هذا الحقل الزامي</span>
          <span v-if="!$v.name2.minLength">يجب أن يتكون الاسم من حرفين على الأقل</span>
          <span v-if="!$v.name2.maxLength">يجب أن يتكون الاسم من 15 حرف على الاكثر</span>
        </div>
      </b-form-group>
      <b-form-group class="col-md-3 mb-3" label="اسم الجد : " label-for="name3">
        <b-form-input
          id="name3"
          type="text"
          placeholder="ادخل اسم الجد"
          v-model="name3"
          :class="{ 'is-invalid': $v.name3.$error }"
        ></b-form-input>
        <div v-if="$v.name3.$error" class="invalid-feedback">
          <span v-if="!$v.name3.required">هذا الحقل الزامي</span>
          <span v-if="!$v.name3.minLength">يجب أن يتكون الاسم من حرفين على الأقل</span>
          <span v-if="!$v.name3.maxLength">يجب أن يتكون الاسم من 15 حرف على الاكثر</span>
        </div>
      </b-form-group>
      <b-form-group class="col-md-3 mb-3" label="اسم اب الجد : " label-for="name4">
        <b-form-input
          id="name4"
          type="text"
          placeholder="ادخل اسم اب الجد"
          v-model="name4"
          :class="{ 'is-invalid': $v.name4.$error }"
        ></b-form-input>
        <div v-if="$v.name4.$error" class="invalid-feedback">
          <span v-if="!$v.name4.required">هذا الحقل الزامي</span>
          <span v-if="!$v.name4.minLength">يجب أن يتكون الاسم من حرفين على الأقل</span>
          <span v-if="!$v.name4.maxLength">يجب أن يتكون الاسم من 15 حرف على الاكثر</span>
        </div>
      </b-form-group>
    </div>
    <div class="row">
      <b-form-group class="col-md-4 mb-3" label=" اللقب : " label-for="family_name">
        <b-form-input
          id="family_name"
          type="text"
          placeholder="ادخل اللقب"
          v-model="family_name"
          :class="{ 'is-invalid': $v.family_name.$error }"
        ></b-form-input>
        <div v-if="$v.family_name.$error" class="invalid-feedback">
          <span v-if="!$v.family_name.required">هذا الحقل الزامي</span>
          <span v-if="!$v.family_name.minLength"
            >يجب أن يتكون اللقب من حرفين على الأقل</span
          >
          <span v-if="!$v.family_name.maxLength"
            >يجب أن يتكون اللقب من 15 حرف على الاكثر</span
          >
        </div>
      </b-form-group>
      <b-form-group
        class="col-md-4 mb-3"
        label="اسم الام الثلاثي : "
        label-for="mother_name"
      >
        <b-form-input
          id="mother_name"
          type="text"
          placeholder="ادخل اسم الام الثلاثي"
          v-model="mother_name"
          :class="{ 'is-invalid': $v.mother_name.$error }"
        ></b-form-input>
        <div v-if="$v.mother_name.$error" class="invalid-feedback">
          <span v-if="!$v.mother_name.required">هذا الحقل الزامي</span>
          <span v-if="!$v.mother_name.minLength"
            >يجب أن يتكون اسم الام الثلاثي من حرفين على الأقل</span
          >
          <span v-if="!$v.mother_name.maxLength"
            >يجب أن يتكون اسم الام الثلاثي من 50 حرف على الاكثر</span
          >
        </div>
      </b-form-group>
      <b-form-group class="col-md-4 mb-3" label=" التشكيل : " label-for="dept">
        <b-form-input
          id="dept"
          type="text"
          placeholder="ادخل التشكيل"
          v-model="dept"
          :class="{ 'is-invalid': $v.dept.$error }"
        ></b-form-input>
        <div v-if="$v.dept.$error" class="invalid-feedback">
          <span v-if="!$v.dept.required">هذا الحقل الزامي</span>
          <span v-if="!$v.dept.minLength">يجب أن يتكون التشكيل من حرفين على الأقل</span>
          <span v-if="!$v.dept.maxLength">يجب أن يتكون التشكيل من 50 حرف على الاكثر</span>
        </div>
      </b-form-group>
    </div>
    <div class="row">
      <b-form-group class="col-md-4 mb-3" label=" الفئة : " label-for="category_id">
        <select
          class="form-control"
          id="category_id"
          v-model="category_id"
          :class="{ 'is-invalid': $v.category_id.$error }"
        >
          <option value="">اختر الفئة</option>
          <option
            v-for="category in list_categories"
            :value="category.id"
            :key="category.id"
          >
            {{ category.name }}
          </option>
        </select>
        <div v-if="$v.category_id.$error" class="invalid-feedback">
          <span v-if="!$v.category_id.required">هذا الحقل الزامي</span>
        </div>
      </b-form-group>
      <b-form-group
        class="col-md-4 mb-3"
        :label="getInjuryCategory() ? 'تاريخ الاصابة :' : 'تاريخ الاستشهاد :'"
        label-for="birth_date"
      >
        <date-picker
          id="date_wound"
          type="date"
          lang="ar"
          value-type="DD-MM-YYYY"
          format="DD-MM-YYYY"
          placeholder='ادخل الصيغة التالية   "يوم ثم شهر ثم سنة"'
          v-model="date_wound"
          :class="{ 'is-invalid': $v.date_wound.$error }"
        ></date-picker>
        <div v-if="$v.date_wound.$error" class="invalid-feedback">
          <span v-if="!$v.date_wound.required">هذا الحقل الزامي</span>
        </div>
      </b-form-group>
      <b-form-group class="col-md-4 mb-3" label=" المحافظة : " label-for="city_id">
        <select
          class="form-control"
          id="city_id"
          v-model="city_id"
          :class="{ 'is-invalid': $v.city_id.$error }"
        >
          <option value="">اختر المحافظة</option>
          <option v-for="city in list_cities" :value="city.id" :key="city.id">
            {{ city.name }}
          </option>
        </select>
        <div v-if="$v.city_id.$error" class="invalid-feedback">
          <span v-if="!$v.city_id.required">هذا الحقل الزامي</span>
        </div>
      </b-form-group>
      <b-form-group
        v-if="getInjuryCategory()"
        class="col-md-12 mb-3"
        label=" نسبة العجز : "
        label-for="disability_ratio"
      >
        <b-form-input
          id="disability_ratio"
          type="text"
          placeholder="ادخل نسبة العجز "
          v-model="disability_ratio"
          :class="{ 'is-invalid': $v.disability_ratio.$error }"
        ></b-form-input>
        <div v-if="$v.disability_ratio.$error" class="invalid-feedback">
          <span v-if="!$v.disability_ratio.required">هذا الحقل الزامي</span>
          <span v-if="!$v.disability_ratio.minValue"
            >يجب أن تكون نسبة العجز 75% على الأقل</span
          >
          <span v-if="!$v.disability_ratio.maxValue"
            >يجب أن تكون نسبة العجز من 100% على الاكثر</span
          >
        </div>
      </b-form-group>
    </div>
  </div>
  <!-- end page title -->
</template>
